var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIconColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    fill: "none",
    viewBox: "0 0 6 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171F5F",
    d: "M5.121 3.879a2.989 2.989 0 0 0-1.14-.715 1.734 1.734 0 1 0-1.962 0 2.988 2.988 0 0 0-1.14.715A2.98 2.98 0 0 0 0 6h.469A2.534 2.534 0 0 1 3 3.469 2.534 2.534 0 0 1 5.531 6H6a2.98 2.98 0 0 0-.879-2.121zM3 3a1.267 1.267 0 0 1-1.266-1.266 1.267 1.267 0 0 1 2.531 0C4.266 2.432 3.699 3 3 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconColor);
export default __webpack_public_path__ + "static/media/user_icon_color.ee1b759c0fdbd9aeb903e47d843f5d1a.svg";
export { ForwardRef as ReactComponent };